export default __webpack_public_path__ + "c8090e604328a6143892abbfdce0894a.png";